import React, {useState, useEffect, useRef, useContext, useMemo} from 'react';
import styles from './modelLeftIndex.module.scss'
import SelectModel from './selectModel/selectModel'
import SelectRatio from './selectRatio'
import Drawer from './drawer/drawer'
import SelectScene from './modelAndcommodityScene/selectScene/selectScene'
import { Tag, Button, Dropdown, notification, Checkbox } from 'antd';
import { IMAGE_TYPE, CLOTH_TYPE } from "@utils/CONST"
import ResolutionSelection from '@view/compoents/ResolutionSelection/ResolutionSelection';
// import SoftEdge from './modelAndcommodityScene/softEdge/softEdge'
import SoftEdge from '@view/page/components/softEdge'
import { GenerateContext } from "@utils/GenerateContext"
import TextTag from '@view/compoents/textTag/textTag'
import StrengthSlider from './modelAndcommodityScene/customScene/components/StrengthSlider'
import { AppContext } from '@utils/AppContext';

const ModelLeftIndex = (props) => {
    const {isProEnv} = useContext(AppContext)
    const {    
        initialized, // taskcache初始化完成
        imageType, // model/dressform/clothes...
        dragScaleRef, dragScale, setDragScale, // 商品+softedge布局等
        bgImage,
        setBgImage,
        aiInteractiveNpy, setAiInteractiveNpy, // npy-套装
        aiInteractiveNpy1, setAiInteractiveNpy1, // npy-上身
        aiInteractiveNpy2, setAiInteractiveNpy2, // npy-下身
        maskAlgoIdRef, // mask算法id-套装
        maskAlgoId1Ref, // mask算法id-上身
        maskAlgoId2Ref, // mask算法id-下身
        segmentResult, setSegmentResult, // 分割结果列表-套装
        segmentResult1, setSegmentResult1, // 分割结果列表-上身
        segmentResult2, setSegmentResult2, // 分割结果列表-下身
        modelStyle, setModelStyle, // 选择的模特
        poseStyle, setPoseStyle, // 选择的姿势
        bgStyle, setBgStyle, // 选择的场景
        outputMaxSize, setOutputMaxSize, // 决定商品生成参数upscale_enable是1/0
        projectId, setProjectId, // 生成的项目id，暂时没什么用
        projectName, setProjectName, // 生成的项目名
        createNum, setCreateNum, // 生成数量
        clothType, setClothType, // 来自服装类型的选择，仅用于衣服图的区分
        subBgId, setSubBgId, // 场景内部子index，目前只能为-1
        faceTag, setFaceTag, // 特征属性：表情
        hairTag, setHairTag, // 特征属性：发型
        faceTagText, setFaceTagText, // 特征属性：表情
        hairTagText, setHairTagText, // 特征属性：发型
        // 商品自定义尺寸
        imgWidthRef,
        imgWidth, setImgWidth,
        imgHeightRef, 
        imgHeight, setImgHeight,
        imgRatioRef, 
        imgRatio, setImgRatio,
        // 自定义场景字段
        definedFlag, setDefinedFlag,
        positivePrompt, setPositivePrompt,
        refImg, setRefImg,
        refImgMask, setRefImgMask,
        refVersion, setRefVersion,
        refStrength, setRefStrength,
        setRefImgLocalInfo,
        defaultPositivePrompt,
        defaultNegativePrompt,
        defaultBkgUrl,
        // 自定义模特
        isSelfDefinedRef,
        selfDefinedImgRef,
        // 清除taskCache
        disableCacheRef,
        clothLoadingFlag, clothLoadingFlag2,
        isSceneFracturing, setIsSceneFracturing,
        dpScale, setDpScale
    } = useContext(GenerateContext)
    const [isLoading, setIsLoading] = useState(false)
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [selectedImg, setSelectedImg] = useState();
    const [drawerSaveModel, setDrawerSaveModel] = useState([]);
    const [drawerSavePose, setDrawerSavePose] = useState([]);
    const [drawerSaveScene, setDrawerSaveScene] = useState([]);
    const [uploadModelMD5, setUploadModelMD5] = useState();
    const [modelOrScene, setModelOrScene] = useState();
    const [refreshRecent, setRefreshRecent] = useState(false);
    const drawerRef = useRef();
    const drawerConRef = useRef();
    const isDrawerOpenRef = useRef(false);
    
    const resolutionRef = useRef()
    const [resolutionDisabled, setResolutionDisabled] = useState(true)
    const [refImgSize, setRefImgSize] = useState() // 自定义场景参考图尺寸

    // 内部字段&函数
    const notFoundModelNoticed = useRef(false)
    const notFoundSceneNoticed = useRef(false)

    // 内部函数
    const onModelChange = (type, modelStyle, version, isSelfDefined=false, selfDefinedImg='') => {
        if(type == 'Model') {
            setModelStyle(modelStyle)
        } else if(type == 'Pose') {
            setPoseStyle(modelStyle)
            isSelfDefinedRef.current = isSelfDefined
            selfDefinedImgRef.current = selfDefinedImg
        }
    }
    const onSceneChange = (bgStyle, version, flag) => {
        // if (flag != 'init') setSubBgId(-1) // 一旦修改了场景，需要将瀑布流带过来的subBgid重置为-1；否则会出现数组越界问题
        setBgStyle(bgStyle)
    }
    const onFaceTagChange = (val, text) => {
        setFaceTag(val)
        setFaceTagText(text)
    }
    const onHairTagChange = (val, text) => {
        setHairTag(val)
        setHairTagText(text)
    }
    const onCreateNumChange = (val) => {
        if(val == 'add') {
            if(createNum < 4) setCreateNum(pre => pre + 1)
        } else if(val == 'reduce') {
            if(createNum > 1) setCreateNum(pre => pre - 1)
        }
    }
    const onCustomChange = ({
        definedFlag,
        positivePrompt,
        refImg,
        refImgMask,
        refImgProcessed,
        refImgLocalInfo,
        refVersion,
        refStrength,
    }) => {
        // 场景切换
        setDefinedFlag(definedFlag)
        setPositivePrompt(positivePrompt)
        setRefImg(refImg)
        setRefImgMask(refImgMask)
        setRefVersion(refVersion)
        setRefStrength(refStrength)
        setRefImgLocalInfo(refImgLocalInfo)
        if (imageType == IMAGE_TYPE.COMMODITY) {
            setBgImage((refVersion == 1 && refImg) || (refVersion == 3 && refImgProcessed))
        }
    }
    const onCanvasChange = (w,h,ratio) => {
        imgWidthRef.current = w
        setImgWidth(w)
        imgHeightRef.current = h
        setImgHeight(h)
        imgRatioRef.current = ratio
        setImgRatio(ratio)
    }
    const foundModelFunc = () => notFoundModelNoticed.current = true // 找到了模特，修改标记
    const notFoundModelFunc = () => {
        if (notFoundModelNoticed.current) return
        notFoundModelNoticed.current = true
        if (!location.state?.rebuild) return
        notification.info({
            message: `提醒`,
            description: `原模特组已更新，请手动选择模特`,
            placement: 'bottomRight',
        })
    } // 没有找到模特，需要弹窗提醒

    const foundSceneFunc = () => notFoundSceneNoticed.current = true // 找到了场景，修改标记
    const notFoundSceneFunc = () => {
        if (notFoundSceneNoticed.current) return
        notFoundSceneNoticed.current = true
        if (!location.state?.rebuild) return
        notification.info({
            message: `提醒`,
            description: `原场景组已更新，请手动选择场景`,
            placement: 'bottomRight',
        })
    } // 没有找到场景，需要弹窗提醒

    const tryOn = useMemo(() => {
        return imageType == IMAGE_TYPE.CLOTHES
    }, [imageType])
    const maskIsReady = useMemo(() => {
        const segs = clothType == CLOTH_TYPE.SUIT ? 
            segmentResult1.concat(segmentResult2) : 
            segmentResult            
        return segs && segs.length > 0
    }, [segmentResult, segmentResult1, segmentResult2, clothType])

    const customChangeFunc = (params) => {
        setRefImgSize(params.refImgSize)
        onCustomChange(params)
    }
    useEffect(() => {
        if (refVersion == 1 || refVersion == 3) { // v1-需要将参考图加载到画布上，需要锁定尺寸
            if (!refImgSize) {
                setResolutionDisabled(false)
                return
            } else {
                if (resolutionRef.current) resolutionRef.current.customSize(refImgSize.width, refImgSize.height)
                setResolutionDisabled(true)
            }
        } else { // v2-不需要将参考图加载到画布上，不需要锁定尺寸
            setResolutionDisabled(false)
        }
    }, [refImgSize, refVersion])

    const createHandle = async () => {
        if(clothLoadingFlag || clothLoadingFlag2 || !maskIsReady) return
        setIsLoading(true)
        try {
            await props.onCreate()
            setRefreshRecent(!refreshRecent)
        } catch (err) {
            console.error(err.message)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleClickOutside = (event) => {
        if (drawerRef.current && 
            !drawerRef.current.contains(event.target) && 
            !event.target.classList.contains('dropdown') && 
            !event.target.closest('.ModelFilterSelect') && 
            !event.target.closest('.ant-select-item') &&
            !event.target.closest('.more_btn')) {
            if(isDrawerOpenRef.current) {
                setIsDrawerOpen(!isDrawerOpenRef.current);
            }
        }
    };

    const toggleDrawer = (e, type) => {
        e.stopPropagation()
        if(type === modelOrScene || !isDrawerOpen) {
            setIsDrawerOpen(!isDrawerOpen)
            isDrawerOpenRef.current = !isDrawerOpen
        }
        setModelOrScene(type)
    }

    const getDrawerDate = (selectedImg) => {
        setSelectedImg(selectedImg)
    }

    const selectModalSave = (selectd, version) => {
        if(modelOrScene == 'Model') {
            setDrawerSaveModel([selectd, version])
        } else if(modelOrScene == 'Pose') {
            setDrawerSavePose([selectd, version])
        } else if(modelOrScene == 'Scene' || modelOrScene == 'Scene2' ) {
            setDrawerSaveScene([selectd, version])
        }
        // setIsDrawerOpen(false)
    }

    const checkIsUploadModel = (md5) => {
        setUploadModelMD5(md5)
    }

    useEffect(() => {
        if(!isDrawerOpen && drawerConRef.current.selected && drawerConRef.current.versionRef) {
            // selectModalSave(drawerConRef.current.selected, drawerConRef.current.versionRef, modelOrScene)
            // drawerConRef.current.setSelected()
        }
    }, [isDrawerOpen])

    const tagCloseClick = (e, T) => {
        e.preventDefault();
        if(T == 't1') {
            onFaceTagChange('default', '默认')
        } else {
            onHairTagChange('default', '默认')
        }
    }

    const FeatureCotent = () => {
        return (
          <div className={styles.feature_content}>
            <TextTag
            faceTag={faceTag}
            hairTag={hairTag}
            faceTagChange={onFaceTagChange}
            hairTagChange={onHairTagChange}
            />
          </div>
        );
    }

    const [dropFlag, setDropflag] = useState(false)
    const dropChange = (flag) => {
        setDropflag(flag)
    }

    // 保持原图场景/场景裂变，不可修改尺寸
    const selectRatioDisabled = useMemo(() => {
        return bgStyle == '00_keep' || isSceneFracturing
    }, [bgStyle, isSceneFracturing])

    const modelAndDressformRender = (
        <>
            {
                imageType == IMAGE_TYPE.MODEL &&
                <SelectRatio
                    disabled={selectRatioDisabled}
                    bgImage={bgImage}
                    value={imgRatio}
                    onChange={(ratio) => onCanvasChange(0,0,ratio)}
                />
            }
            {
                imageType == 'clothes'?<SelectModel
                    isposeType='tyronModel'
                    type={modelOrScene || 'Model'}
                    tryOn={false}
                    pageType={'Model'}
                    modelName={modelStyle}
                    getSelectModal={onModelChange}
                    notFoundModelFunc={notFoundModelFunc}
                    foundModelFunc={foundModelFunc}
                    toggleDrawer={toggleDrawer}
                    getDrawerDate={getDrawerDate}
                    drawerSaveSelect={drawerSaveModel}
                    checkIsUploadModel={checkIsUploadModel}
                    refreshRecent={refreshRecent}
                />: null
            }
            <SelectModel
                isposeType={tryOn?'pose': 'model'}
                type={modelOrScene || (tryOn? 'Pose': 'Model')}
                tryOn={tryOn}
                pageType={imageType}
                modelName={tryOn?poseStyle: modelStyle}
                getSelectModal={onModelChange}
                notFoundModelFunc={notFoundModelFunc}
                foundModelFunc={foundModelFunc}
                toggleDrawer={toggleDrawer}
                getDrawerDate={getDrawerDate}
                drawerSaveSelect={tryOn?drawerSavePose: drawerSaveModel}
                checkIsUploadModel={checkIsUploadModel}
                refreshRecent={refreshRecent}
            />
            {
                imageType == IMAGE_TYPE.MODEL? <Dropdown
                trigger={['click']}
                onOpenChange={dropChange}
                dropdownRender={(menu) => <FeatureCotent/>}
                >
                    <div className={styles.tag_styl}>
                    <span className={styles.tag_title}>特征</span>
                    <div className={styles.tag_box}>
                        <Tag closeIcon={faceTagText != '默认'} onClose={(e) => tagCloseClick(e, 't1')}>{faceTagText == '默认'? '默认表情': faceTagText}</Tag>
                        <Tag closeIcon={hairTagText != '默认'} onClose={(e) => tagCloseClick(e, 't2')}>{hairTagText == '默认'? '默认发型': hairTagText}</Tag>
                        <span className={styles.tag_create}><img className={dropFlag? styles.tag_img: null} src={require('@assets/images/Frame 746.png')} alt="" /></span>
                    </div>
                </div>
              </Dropdown>: null
            }
            <SelectScene
                title='预设风格'
                clothCategory={""}
                definedFlag={definedFlag}
                positivePrompt={positivePrompt}
                bkgUrl={refImg}
                refVersion={refVersion}
                refStrength={refStrength}
                onCustomChange={customChangeFunc}
                sceneType={imageType}
                getSceneImg={onSceneChange}
                sceneName={bgStyle}
                notFoundSceneFunc={notFoundSceneFunc}
                foundSceneFunc={foundSceneFunc}
                toggleDrawer={toggleDrawer}
                drawerSaveSelect={drawerSaveScene}
                getDrawerDate={getDrawerDate}
                refreshRecent={refreshRecent}
            />
            {
                imageType == IMAGE_TYPE.MODEL? <SelectScene
                title='预设参考图'
                clothCategory={""}
                definedFlag={definedFlag}
                positivePrompt={positivePrompt}
                bkgUrl={refImg}
                refVersion={refVersion}
                refStrength={refStrength}
                onCustomChange={customChangeFunc}
                sceneType={imageType}
                getSceneImg={onSceneChange}
                sceneName={bgStyle}
                notFoundSceneFunc={notFoundSceneFunc}
                foundSceneFunc={foundSceneFunc}
                toggleDrawer={toggleDrawer}
                drawerSaveSelect={drawerSaveScene}
                getDrawerDate={getDrawerDate}
                refreshRecent={refreshRecent}
                />: null
            }
            {
                !isProEnv &&
                definedFlag != 1 &&
                imageType == IMAGE_TYPE.MODEL &&
                <div>
                    <Checkbox checked={isSceneFracturing} onChange={e => setIsSceneFracturing(e.target.checked)}>场景裂变</Checkbox>
                    <StrengthSlider leftTips="更加自由" rightTips="非常相似" version={1} value={dpScale} onChange={setDpScale} showTooltip />
                </div>
            }
        </>
    )

    const commodityRender = (
        <>
            <div className={styles.modelLeft_title}>图像尺寸</div>
            <ResolutionSelection
                ref={resolutionRef}
                disabled={resolutionDisabled}
                initImgRatio={imgRatio}
                initImgWidth={imgWidth}
                initImgHeight={imgHeight}
                onChange={onCanvasChange}
            />
            <SelectScene
                title='预设风格'
                definedFlag={definedFlag}
                positivePrompt={positivePrompt}
                bkgUrl={refImg}
                refVersion={refVersion}
                refStrength={refStrength}
                onCustomChange={customChangeFunc}
                sceneType={imageType}
                getSceneImg={onSceneChange}
                sceneName={bgStyle}
                notFoundSceneFunc={notFoundSceneFunc}
                foundSceneFunc={foundSceneFunc}
                toggleDrawer={toggleDrawer}
                drawerSaveSelect={drawerSaveScene}
                getDrawerDate={getDrawerDate}
                refreshRecent={refreshRecent}
            />
            {
                definedFlag == 0?<>
                <div className={styles.modelLeft_title}>添加元素<span>（非必选）</span></div>
                <SoftEdge
                    getEdgeUrl={props.onEdgeChange}
                    toggleDrawer={toggleDrawer}
                />
                </>: null
            }
            
        </>
    )

    // 虹豆消耗：衣服图40/张；其他10/张
    const consumAmount = useMemo(() => {
        if (imageType == IMAGE_TYPE.CLOTHES) {
            return createNum * 40
        } else {
            return createNum * 10
        }
    }, [imageType, createNum])


    const createBtnDisabled = useMemo(() => {
        return (
            clothLoadingFlag ||
            clothLoadingFlag2 ||
            !maskIsReady ||
            (imageType == IMAGE_TYPE.COMMODITY && definedFlag != 0 && (!refImg && !positivePrompt)) ||
            (imageType == IMAGE_TYPE.MODEL && definedFlag == 1 && (!refImg && !positivePrompt))
        )
    }, [imageType, definedFlag, refImg, positivePrompt, clothLoadingFlag, clothLoadingFlag2, maskIsReady])

    const leftBottom = (
        <>
            <div className={styles.create_styl}>
                <span style={{marginRight: '10px'}}>生成图片数</span>
                <span className={`${styles.num_btn} ${createNum == 1 && styles.disabled}`} style={{marginRight: '8px'}} onClick={(e) => onCreateNumChange('reduce')}>-</span>
                <span style={{marginRight: '4px'}}>{createNum}</span>
                <span className={`${styles.num_btn} ${createNum == 4 && styles.disabled}`} style={{marginRight: '10px'}} onClick={(e) => onCreateNumChange('add')} >+</span>
                <span>张</span>
                <span className={styles.use_point}>消耗 <img src={require('@assets/images/arcbean2.png')}/><span>{consumAmount}</span></span>
            </div>
            <Button
                className={styles.create_btn}
                disabled={createBtnDisabled}
                type="primary"
                loading={isLoading}
                onClick={createHandle}
            >{'生 成'}</Button>
        </>
    )

    return (
        <div className={styles.mainBox}>
            <div className={isDrawerOpen? `${styles.modelLeftIndex} ${styles.modelLeftIndex_radius}`: styles.modelLeftIndex}>
                <div className={styles.modelLeftbox}>
                    { (initialized && imageType != IMAGE_TYPE.COMMODITY) && modelAndDressformRender }
                    { (initialized && imageType == IMAGE_TYPE.COMMODITY) && commodityRender }
                </div>
                {leftBottom}
                {/* { !maskIsReady && <div className={styles.left_mask}></div> } */}
            </div>

            <div ref={drawerRef} className={`${styles.modelDrawerbox} ${isDrawerOpen ? styles.drawer_open : ''}`}>
                <Drawer
                    type={modelOrScene}
                    ref={drawerConRef}
                    selectedName={selectedImg}
                    tryOn={tryOn}
                    isDrawerOpen={isDrawerOpen}
                    uploadModelMD5={uploadModelMD5}
                    options={{showTitle: true}}
                    setIsDrawerOpen={() => setIsDrawerOpen(false)}
                    sceneType={imageType}
                    modelStyle={modelStyle}
                    poseStyle={poseStyle}
                    sceneStyle={bgStyle}

                    faceTag={faceTag}
                    pageType={imageType}
                    hairTag={hairTag}
                    faceTagChange={onFaceTagChange}
                    hairTagChange={onHairTagChange}

                    selectModalSave={selectModalSave}
                    getEdgeUrl={props.onEdgeChange}
                />
            </div>
        </div>
    )
    
}

export default ModelLeftIndex